























import mixins from 'vue-typed-mixins';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
    items: {
      type: Array as () => any[],
    },
    headers: {
      type: Array as () => any[],
    },
  },

  computed: {
    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },
});
